module.exports = __webpack_public_path__ + "static/media/sheets.7a1b7961.svg";